import React from "react";
import Footer from "../presentational/Footer/";
import FooterBox from "../presentational/FooterBox/";

const FooterContainer = () => {
    const left = (
        <FooterBox title="За контакти">
            <p>
                Тел.:{" "}
                00359 /0/361 62612/61137/61135;
            </p>
            <p>
                Факс:{" "}
                00359 361 61133
            </p>
            <p>
                E-mail:{" "}
                <a href="mailto:info@formoplastbg.com" className="footer-link">
                    info@formoplastbg.com
                </a>
            </p>
        </FooterBox>
    );

    const leftMiddle = (
        <FooterBox title="Адрес">
            <p>Формопласт АД, Промишлена зона юг, 6600 Кърджали</p>

            <div className="footerGif">
                <img src="https://www.formoplastbg.com/Ru/at_sign_rotating.gif" alt="gif" />
            </div>
        </FooterBox>
    );

    const rightMiddle = (
        <FooterBox title="Политики">
            <div style={{ display: "grid", gap: 10 }}>
                <a className="footer-link" href={"https://formoplastbg.com/Bg/Politika_GDPR_Formoplast_ok.pdf"} target="_blank"> Политика за личните данни </a>
                <a className="footer-link" href={"https://formoplastbg.com/Bg/PPpersonal.pdf"} target="_blank"> Политика за поверителност при подбор на персонал </a>
                <a className="footer-link" href={"https://formoplastbg.com/Bg/doc_2.PDF"} target="_blank"> Политика за възнагражденията на членовете на съвета на директорите </a>
                <a className="footer-link" href={"https://formoplastbg.com/Bg/doc_3.PDF"} target="_blank"> Доклад за прилагане на политика за възнагражденията на членовете на съвета на директорите </a>
            </div>
        </FooterBox>
    );

    const right = <img className="footerMaps" src={"https://www.formoplastbg.com/Bg/map_of_bulgaria.gif"} alt="map" />;

    return <Footer left={left} leftMiddle={leftMiddle} rightMiddle={rightMiddle} right={right} />;
}

export default FooterContainer;



// WEBPACK FOOTER //
// ./src/containers/Footer.js